<template>
  <div
    v-if="visible"
    class="nup-dialog"
    @click.self="$emit('close')"
  >
    <div class="nup-dialog__wrap">
      <div class="nup-dialog__card">
        <img
          class="nup-dialog__mascot"
          :src="mascot"
          alt=""
          width="229"
          height="256"
        />
        <div class="nup-dialog__line"></div>
        <p class="nup-dialog__title">{{ copy.enrollSuccessTitle }}</p>
        <p class="nup-dialog__desc">{{ copy.enrollSuccessDesc }}</p>
        <button
          type="button"
          class="nup-dialog__btn"
          @click="$emit('deposit')"
        >
          {{ isEn ? copy.depositNow : copy.deposit }}
        </button>
      </div>
      <button
        type="button"
        class="nup-dialog__close"
        @click="$emit('close')"
      >
        <img
          :src="closeIcon"
          :alt="copy.close"
          width="48"
          height="48"
        />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { getCopy } from '../constants/copy';
import { useNupLang } from '../composables/use-nup-lang';
import mascot from '../assets/dialog-mascot.png';
import closeIcon from '../assets/dialog-close.svg';
const __sfc_main = {};
__sfc_main.props = {
  visible: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    isEn
  } = useNupLang();
  const copy = computed(() => getCopy(isEn.value));
  return {
    mascot,
    closeIcon,
    isEn,
    copy
  };
};
export default __sfc_main;
</script>

<style scoped>
.nup-dialog {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 80px 24px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.45);
}

.nup-dialog__wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 580px;
  max-width: 100%;
  margin: auto;
}

.nup-dialog__card {
  width: 100%;
  padding: 40px 48px 48px;
  border-radius: 40px;
  background: #fff;
  text-align: center;
  box-sizing: border-box;
}

.nup-dialog__mascot {
  display: block;
  width: 229px;
  height: 256px;
  margin: 0 auto;
  object-fit: contain;
}

.nup-dialog__line {
  height: 1px;
  background: #eee;
  margin: 0 0 32px;
}

.nup-dialog__title {
  margin: 0;
  font-size: 36px;
  color: #000;
  font-weight: 600;
}

.nup-dialog__desc {
  margin: 20px 0 40px;
  font-size: 28px;
  color: #7a7a7a;
  line-height: 1.4;
}

.nup-dialog__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 400px;
  height: 88px;
  padding: 0;
  border: none;
  border-radius: 44px;
  background: #ff6900;
  color: #fff;
  font-size: 32px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
}

.nup-dialog__close {
  margin-top: 32px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  width: 48px;
  height: 48px;
}

.nup-dialog__close img {
  display: block;
  width: 48px;
  height: 48px;
}

.nup-page.is-pc .nup-dialog {
  padding: 48px 24px;
}

.nup-page.is-pc .nup-dialog__wrap {
  width: 580px;
}

.nup-page.is-pc .nup-dialog__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 580px;
  height: 580px;
  padding: 40px 48px 48px;
  border-radius: 40px;
  overflow: hidden;
}

.nup-page.is-pc .nup-dialog__mascot {
  width: 229px;
  height: 256px;
  flex-shrink: 0;
}

.nup-page.is-pc .nup-dialog__btn {
  flex-shrink: 0;
  width: 280px;
  height: 70px;
  margin-top: auto;
  font-size: 28px;
  border-radius: 35px;
}

.nup-page.is-pc.is-en .nup-dialog__title {
  font-size: 32px;
}

.nup-page.is-pc.is-en .nup-dialog__desc {
  margin: 12px 0 0;
  font-size: 20px;
  line-height: 1.35;
}

.nup-page.is-pc .nup-dialog__close {
  margin-top: 32px;
}
</style>
